import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Drawer, DrawerContent, DrawerHeader, DrawerTitle } from './ui/drawer';
import { ArrowRight, ShareNetwork, MapPin, CurrencyDollar } from '@phosphor-icons/react';
import { toast } from '../hooks/use-toast';
import { haptic } from '../utils/haptics';
import { withUtm } from '../utils/analytics';

export const JobQuickActionsSheet = ({ job, open, onOpenChange }) => {
  const navigate = useNavigate();
  if (!job) return null;

  const budget = job.budget_max ? `$${Number(job.budget_max).toLocaleString()}` : job.budget_min ? `$${Number(job.budget_min).toLocaleString()}+` : 'Negotiable';

  const share = async () => {
    haptic(8);
    const baseUrl = `${window.location.origin}/job/${job._id}`;
    const text = `${job.title} — ${budget}${job.location ? ` in ${job.location}` : ''}`;
    try {
      if (navigator.share) {
        await navigator.share({ title: job.title, text, url: withUtm(baseUrl, { medium: 'webshare', campaign: 'job_share', content: job._id }) });
      } else {
        await navigator.clipboard.writeText(withUtm(baseUrl, { medium: 'copy_link', campaign: 'job_share', content: job._id }));
        toast({ title: 'Link copied!', description: 'Job link copied to clipboard.' });
      }
    } catch {
      // user cancelled share
    }
    onOpenChange(false);
  };

  return (
    <Drawer open={open} onOpenChange={onOpenChange}>
      <DrawerContent className="border-t-4 border-black" data-testid="job-quick-actions-sheet">
        <DrawerHeader className="text-left pb-2">
          <DrawerTitle className="font-black uppercase tracking-tight line-clamp-2">{job.title}</DrawerTitle>
          <div className="flex flex-wrap gap-3 text-sm text-neutral-500 font-medium mt-1">
            <span className="inline-flex items-center gap-1 text-green-600 font-bold"><CurrencyDollar size={16} weight="bold" />{budget}</span>
            {job.location && <span className="inline-flex items-center gap-1"><MapPin size={16} weight="bold" />{job.location}</span>}
          </div>
        </DrawerHeader>
        <div className="px-4 pb-8 space-y-3">
          <button
            onClick={() => { haptic(8); onOpenChange(false); navigate(`/job/${job._id}`); }}
            className="w-full flex items-center justify-center gap-2 h-14 bg-[#2B4C6F] text-white font-bold text-lg rounded-xl border-2 border-black shadow-[3px_3px_0px_#000] active:translate-y-1 active:shadow-none transition-all"
            data-testid="sheet-view-job-btn"
          >
            View & Apply <ArrowRight size={22} weight="bold" />
          </button>
          <button
            onClick={share}
            className="w-full flex items-center justify-center gap-2 h-14 bg-white dark:bg-neutral-800 text-neutral-900 dark:text-white font-bold text-lg rounded-xl border-2 border-black dark:border-neutral-600 shadow-[3px_3px_0px_#000] active:translate-y-1 active:shadow-none transition-all"
            data-testid="sheet-share-job-btn"
          >
            <ShareNetwork size={22} weight="bold" /> Share Job
          </button>
        </div>
      </DrawerContent>
    </Drawer>
  );
};

export default JobQuickActionsSheet;
